
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Scroll reveal */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Sticky header shadow + nav (hover-intent dropdowns on desktop, drawer + accordion on mobile) */
  var MOBILE = 900;
  function isMobile() { return window.innerWidth <= MOBILE; }
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';
    var ticking = false;
    var lastY = Math.max(window.scrollY, 0);
    var JITTER = 5;          // ignore sub-pixel wobble and trackpad noise
    var REVEAL_FLOOR = 90;   // always visible this close to the top

    function navIsOpen() {
      var nav = header.querySelector('[data-nav]');
      if (nav && nav.classList.contains('is-open')) return true;
      if (header.querySelector('.nav-item.is-open')) return true;
      if (header.contains(document.activeElement)) return true;
      var d = document.querySelector('[data-cart-drawer]');
      return !!(d && d.classList.contains('is-open'));
    }

    function setHidden(on) { header.classList.toggle('is-hidden', on); }

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.max(window.scrollY, 0);
        var delta = y - lastY;
        header.classList.toggle('is-scrolled', y > 60);

        if (Math.abs(delta) >= JITTER) {
          if (y <= REVEAL_FLOOR || navIsOpen()) {
            setHidden(false);
          } else if (delta > 0) {
            setHidden(true);   // scrolling down: slide out
          } else {
            setHidden(false);  // scrolling up: slide back in
          }
          lastY = y;
        }
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    header.classList.toggle('is-scrolled', window.scrollY > 60);

    var burger = header.querySelector('[data-burger]');
    var nav = header.querySelector('[data-nav]');
    var backdrop = header.querySelector('[data-nav-backdrop]');
    function setNav(open) {
      if (!nav) return;
      if (open) header.classList.remove('is-hidden');
      nav.classList.toggle('is-open', open);
      if (backdrop) backdrop.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (burger) burger.setAttribute('aria-expanded', String(open));
    }
    if (burger && nav) burger.addEventListener('click', function () { setNav(!nav.classList.contains('is-open')); });
    if (backdrop) backdrop.addEventListener('click', function () { setNav(false); });
    var closeBtn = header.querySelector('[data-nav-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { setNav(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && header.isConnected) { setNav(false); closeAll(); } });

    var items = header.querySelectorAll('[data-nav-item]');
    function setItem(item, open) {
      if (open) header.classList.remove('is-hidden');
      item.classList.toggle('is-open', open);
      var t = item.querySelector('[data-nav-trigger]');
      if (t) t.setAttribute('aria-expanded', String(open));
    }
    function closeAll(except) { items.forEach(function (it) { if (it !== except) setItem(it, false); }); }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-nav-trigger]');
      if (!trigger) return;
      var openT, closeT;
      // Desktop: hover intent, small close delay so the pointer can travel into the panel
      item.addEventListener('pointerenter', function (e) {
        if (isMobile() || e.pointerType === 'touch') return;
        clearTimeout(closeT);
        openT = setTimeout(function () { closeAll(item); setItem(item, true); }, 60);
      });
      item.addEventListener('pointerleave', function (e) {
        if (isMobile() || e.pointerType === 'touch') return;
        clearTimeout(openT);
        closeT = setTimeout(function () { setItem(item, false); }, 180);
      });
      // Touch / mobile: first tap opens, second tap follows the link
      trigger.addEventListener('click', function (e) {
        var touch = isMobile() || (e.pointerType === 'touch') || (window.matchMedia && window.matchMedia('(hover: none)').matches);
        if (!touch) return;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          if (!isMobile()) closeAll(item);
          setItem(item, true);
        }
      });
      // Keyboard
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); setItem(item, true); var first = item.querySelector('.nav-menu a'); if (first) first.focus(); }
      });
      item.addEventListener('focusout', function () {
        setTimeout(function () { if (!item.contains(document.activeElement) && !isMobile()) setItem(item, false); }, 10);
      });
    });
    document.addEventListener('click', function (e) {
      if (header.isConnected && !isMobile() && !header.contains(e.target)) closeAll();
    });
    window.addEventListener('resize', function () { if (!isMobile()) setNav(false); });
  }

  /* Horizontal rails: one step per card, one dot per card, swipe/drag/arrows */
  function railItems(rail) { return Array.prototype.filter.call(rail.children, function (el) { return el.offsetWidth > 0; }); }
  function railStep(rail) {
    var items = railItems(rail);
    if (items.length < 2) return items[0] ? items[0].offsetWidth : rail.clientWidth;
    return items[1].offsetLeft - items[0].offsetLeft;
  }
  function railIndex(rail) {
    var max = rail.scrollWidth - rail.clientWidth;
    var items = railItems(rail);
    if (max <= 2 || !items.length) return 0;
    if (rail.scrollLeft >= max - 2) return items.length - 1;
    var step = railStep(rail) || 1;
    return Math.min(items.length - 1, Math.max(0, Math.round(rail.scrollLeft / step)));
  }
  function scrollRailTo(rail, i) {
    var items = railItems(rail);
    if (!items.length) return;
    i = Math.max(0, Math.min(items.length - 1, i));
    var left = items[i].offsetLeft - items[0].offsetLeft;
    rail.scrollTo({ left: left, behavior: 'smooth' });
  }
  function initRails(root) {
    (root || document).querySelectorAll('[data-rail-btn]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var rail = document.getElementById(btn.getAttribute('data-rail-target'));
        if (!rail) return;
        var dir = btn.getAttribute('data-rail-btn') === 'prev' ? -1 : 1;
        var cur = railIndex(rail);
        var max = rail.scrollWidth - rail.clientWidth;
        if (dir < 0 && rail.scrollLeft >= max - 2) {
          // from the clamped end, step back one card from the real position
          var step = railStep(rail) || 1;
          cur = Math.ceil(rail.scrollLeft / step);
        }
        scrollRailTo(rail, cur + dir);
      });
    });
    initRailPagination(root);
    initRailDrag(root);
  }

  /* Mouse drag-to-scroll (touch already swipes natively) */
  function initRailDrag(root) {
    (root || document).querySelectorAll('.rail').forEach(function (rail) {
      if (rail.dataset.drag) return;
      rail.dataset.drag = '1';
      var down = false, moved = false, startX = 0, startLeft = 0;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) < 6) return;
        if (!moved) { moved = true; rail.classList.add('is-dragging'); }
        rail.scrollLeft = startLeft - dx;
      });
      function up() {
        if (!down) return;
        down = false;
        if (moved) {
          rail.classList.remove('is-dragging');
          scrollRailTo(rail, railIndex(rail));
          var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          rail.addEventListener('click', block, true);
          setTimeout(function () { rail.removeEventListener('click', block, true); }, 50);
        }
      }
      rail.addEventListener('pointerup', up);
      rail.addEventListener('pointercancel', up);
      rail.addEventListener('pointerleave', up);
    });
  }

  function initRailPagination(root) {
    (root || document).querySelectorAll('.rail-wrap').forEach(function (wrap) {
      if (wrap.dataset.paged) return;
      var rail = wrap.querySelector('.rail');
      if (!rail) return;
      wrap.dataset.paged = '1';

      var prev = wrap.querySelector('[data-rail-btn="prev"]');
      var next = wrap.querySelector('[data-rail-btn="next"]');
      var dots = document.createElement('div');
      dots.className = 'rail-dots';
      dots.setAttribute('role', 'tablist');
      dots.setAttribute('aria-label', 'Carousel pagination');
      wrap.appendChild(dots);

      function build() {
        var n = railItems(rail).length;
        var overflow = rail.scrollWidth - rail.clientWidth > 4;
        if (n < 2 || !overflow) { dots.innerHTML = ''; return; }
        if (dots.children.length === n) return;
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rail-dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Go to item ' + (i + 1) + ' of ' + n);
          b.dataset.index = i;
          b.addEventListener('click', function () { scrollRailTo(rail, Number(this.dataset.index)); });
          dots.appendChild(b);
        }
      }
      var centred = rail.hasAttribute('data-rail-center');
      function markCentre() {
        if (!centred) return;
        var mid = rail.scrollLeft + rail.clientWidth / 2;
        var best = null, bestDist = Infinity;
        Array.prototype.forEach.call(rail.children, function (el) {
          var c = el.offsetLeft + el.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = el; }
        });
        Array.prototype.forEach.call(rail.children, function (el) {
          el.classList.toggle('is-active', el === best);
        });
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        wrap.classList.toggle('has-overflow', max > 4);
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
        var active = railIndex(rail);
        Array.prototype.forEach.call(dots.children, function (d, i) {
          var on = i === active;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', String(on));
        });
        markCentre();
      }
      build(); sync();
      var t = false;
      rail.addEventListener('scroll', function () {
        if (t) return;
        t = true;
        requestAnimationFrame(function () { sync(); t = false; });
      }, { passive: true });
      window.addEventListener('resize', function () { build(); sync(); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { build(); sync(); }).observe(rail);
      // images loading late change scrollWidth
      rail.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', function () { build(); sync(); }, { once: true }); });
    });
  }

  /* Hero slideshow */
  function initSlideshow(root) {
    (root || document).querySelectorAll('[data-slideshow]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var slides = el.querySelectorAll('[data-slide]');
      var dots = el.querySelectorAll('[data-slide-dot]');
      if (slides.length < 2) return;
      var i = 0, paused = false;
      var speed = parseInt(el.getAttribute('data-autoplay-speed') || '6', 10) * 1000;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
      el.addEventListener('mouseenter', function () { paused = true; });
      el.addEventListener('mouseleave', function () { paused = false; });
      if (el.getAttribute('data-autoplay') === 'true') {
        if (el._timer) clearInterval(el._timer);
        el._timer = setInterval(function () {
          if (!el.isConnected) { clearInterval(el._timer); return; }
          if (!paused && !document.hidden) show(i + 1);
        }, speed);
      }
    });
  }

  /* Wishlist (localStorage, keyed by product handle) */
  var WKEY = 'lamboos:wishlist';
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (err) {}
    document.dispatchEvent(new CustomEvent('lamboos:wishlist:updated', { detail: list }));
  }
  function paintWishlist(root) {
    var list = readWishlist();
    (root || document).querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist')) !== -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', String(on));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }
  function initWishlist(root) {
    (root || document).querySelectorAll('[data-wishlist]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-wishlist');
        var list = readWishlist();
        var idx = list.indexOf(id);
        if (idx === -1) list.push(id); else list.splice(idx, 1);
        writeWishlist(list);
        paintWishlist();
      });
    });
    paintWishlist(root);
  }

  /* Wishlist page: render saved products from /products/{handle}.js */
  function money(cents) {
    var fmt = (window.Lamboos && window.Lamboos.moneyFormat) || '₹ {{amount_no_decimals}}';
    var n = cents / 100;
    var withDec = n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = Math.round(n).toLocaleString('en-IN');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount\s*\}\}/, withDec).replace(/<[^>]+>/g, '');
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function initWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var count = document.querySelector('[data-wishlist-total]');
    var clear = document.querySelector('[data-wishlist-clear]');
    if (clear) clear.addEventListener('click', function () { writeWishlist([]); paintWishlist(); render(); });
    function render() {
      var list = readWishlist();
      if (count) count.textContent = list.length + (list.length === 1 ? ' item' : ' items');
      if (empty) empty.hidden = list.length > 0;
      grid.hidden = list.length === 0;
      grid.innerHTML = '';
      list.forEach(function (handle) {
        var card = document.createElement('div');
        card.className = 'pcard';
        card.innerHTML = '<div class="pcard__media"></div><h3 class="pcard__title">&nbsp;</h3>';
        grid.appendChild(card);
        fetch('/products/' + handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : '';
          var alt = p.images && p.images[1] ? p.images[1].replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : '';
          var sale = p.compare_at_price && p.compare_at_price > p.price;
          card.innerHTML =
            '<a class="pcard__media" href="/products/' + esc(handle) + '">' +
              (img ? '<img class="pcard__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
              (alt ? '<img class="pcard__img pcard__img--alt" src="' + esc(alt) + '" alt="" loading="lazy">' : '') +
              (sale ? '<span class="tag tag--sale pcard__badge">Sale</span>' : (p.available ? '' : '<span class="tag tag--sold pcard__badge">Sold out</span>')) +
            '</a>' +
            (p.vendor ? '<span class="pcard__vendor">' + esc(p.vendor) + '</span>' : '') +
            '<h3 class="pcard__title"><a href="/products/' + esc(handle) + '">' + esc(p.title) + '</a></h3>' +
            '<span class="pcard__stock ' + (p.available ? 'pcard__stock--in' : 'pcard__stock--out') + '">' + (p.available ? '✓ In Stock!' : 'Out of stock!') + '</span>' +
            '<div class="pcard__foot"><span class="pcard__price">' + money(p.price) + (sale ? '<s>' + money(p.compare_at_price) + '</s>' : '') + '</span>' +
              '<div class="pcard__actions">' +
                '<button type="button" class="pcard__btn is-on" data-wishlist="' + esc(handle) + '" aria-label="Remove from wishlist"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button>' +
                (v && p.available ? '<button type="button" class="pcard__btn pcard__btn--add" data-quick-add="' + v.id + '" aria-label="Add to cart"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></button>' : '') +
              '</div></div>';
          initWishlist(card);
        }).catch(function () { card.remove(); });
      });
    }
    render();
    document.addEventListener('lamboos:wishlist:updated', function () {
      // remove cards whose handle is no longer saved (toggle from the card itself)
      var list = readWishlist();
      grid.querySelectorAll('[data-wishlist]').forEach(function (b) { if (list.indexOf(b.getAttribute('data-wishlist')) === -1) b.closest('.pcard').remove(); });
      if (count) count.textContent = list.length + (list.length === 1 ? ' item' : ' items');
      if (empty) empty.hidden = list.length > 0;
      grid.hidden = list.length === 0;
    });
  }

  /* Viral rail: play in place, one video at a time */
  function embedSrc(url) {
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1';
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }
  function stopCard(card) {
    if (!card) return;
    card.classList.remove('is-playing');
    var vid = card.querySelector('video');
    if (vid) { try { vid.pause(); } catch (e) {} }
    var slot = card.querySelector('[data-video-slot][data-embed]');
    if (slot) slot.innerHTML = '';
  }
  function initVideoCards(root) {
    (root || document).querySelectorAll('[data-video-play]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-vcard]');
        if (!card) return;
        document.querySelectorAll('[data-vcard].is-playing').forEach(function (other) {
          if (other !== card) stopCard(other);
        });
        var slot = card.querySelector('[data-video-slot]');
        var url = slot && slot.getAttribute('data-embed');
        if (url) {
          var src = embedSrc(url);
          if (!src) { window.open(url, '_blank', 'noopener'); return; }
          slot.innerHTML = '<iframe src="' + src + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Video"></iframe>';
        }
        card.classList.add('is-playing');
        var vid = card.querySelector('video');
        if (vid) { try { vid.play(); } catch (e) {} }
      });
    });
  }

  /* Product gallery */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(function (g) {
      if (g.dataset.bound) return;
      g.dataset.bound = '1';
      g.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        selectMedia(g, thumb.getAttribute('data-gallery-thumb'));
      });
    });
  }
  function selectMedia(g, id) {
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-gallery-thumb') === id);
    });
    g.querySelectorAll('[data-gallery-image]').forEach(function (img) {
      img.hidden = img.getAttribute('data-gallery-image') !== id;
    });
  }
  window.lamboosSelectMedia = function (id) {
    var g = document.querySelector('[data-gallery]');
    if (g && id) selectMedia(g, String(id));
  };

  /* Variant picker */
  function initVariantPicker(root) {
    (root || document).querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';
      var form = document.getElementById(picker.getAttribute('data-form'));
      var dataEl = document.getElementById(picker.getAttribute('data-variants'));
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      picker.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(picker.querySelectorAll('[data-option-index]'), function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        chosen.forEach(function (v, i) {
          var out = picker.querySelector('[data-option-value="' + i + '"]');
          if (out) out.textContent = v || '';
        });
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        })[0];
        updateVariant(match, form);
      });
    });
  }

  function updateVariant(variant, form) {
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var submit = form ? form.querySelector('[data-add-button]') : null;
    var priceEl = document.querySelector('[data-price-now]');
    var compareEl = document.querySelector('[data-price-compare]');
    var skuEl = document.querySelector('[data-sku]');
    var stockEl = document.querySelector('[data-variant-stock]');

    if (!variant) {
      if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    if (priceEl) priceEl.innerHTML = variant.price_formatted;
    if (compareEl) {
      compareEl.innerHTML = variant.compare_at_price_formatted || '';
      compareEl.hidden = !variant.compare_at_price_formatted;
    }
    if (skuEl) skuEl.textContent = variant.sku || '';
    if (stockEl) {
      stockEl.textContent = variant.stock_label || '';
      stockEl.className = 'pcard__stock ' + (variant.stock_class || '');
    }
    if (variant.featured_media_id) window.lamboosSelectMedia(variant.featured_media_id);
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* Quantity steppers */
  function initQty(root) {
    (root || document).querySelectorAll('[data-qty]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var input = el.querySelector('input');
      el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-step]');
        if (!btn || !input) return;
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var next = Math.max(parseInt(input.getAttribute('min') || '1', 10), (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* Collection facets */
  function initFacets() {
    var toggle = document.querySelector('[data-facets-toggle]');
    var panel = document.querySelector('[data-facets]');
    if (toggle && panel) toggle.addEventListener('click', function () { panel.classList.toggle('is-open'); });

    var form = document.querySelector('[data-facet-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) form.submit();
      });
    }
    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  ready(function () {
    initHeader();
    initReveal();
    initRails();
    initSlideshow();
    initWishlist();
    initWishlistPage();
    initVideoCards();
    initGallery();
    initVariantPicker();
    initQty();
    initFacets();
  });

  /* Theme editor re-init */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initRails(e.target); initSlideshow(e.target);
    initWishlist(e.target); initGallery(e.target); initVariantPicker(e.target); initQty(e.target);
    initVideoCards(e.target);
    initHeader(); initFacets();
  });

  window.LamboosUI = { initReveal: initReveal, initWishlist: initWishlist, initQty: initQty };
})();
